import Rating from "@JohnLewisPartnership/jl-design-system/dist/components/rating/Rating";
import { CardComponentProps } from "@~/types/types";
import { PDPLink } from "../__shared__/PDPLink/PDPLink";

export const Ratings = ({ product }: Pick<CardComponentProps, "product">) => {
  if (!product.reviewSummary || !product.reviewSummary.numberOfReviews) {
    return null;
  }

  return (
    <PDPLink product={product} componentName="Ratings" tabIndex={-1}>
      <Rating
        size="large"
        rating={{
          averageRating: product.reviewSummary.averageRating,
          reviews: product.reviewSummary.numberOfReviews,
        }}
      />
    </PDPLink>
  );
};
